export default "__VITE_ASSET__QPy5r1f5__"